<div class="flex-fill d-flex flex-row">
  <div class="flex-shrink-0 sidebar">
    <div class="toolbar m-3">
      <dx-form [formData]="filter" style="max-width: 150px">
        <dxi-form-item dataField="startDate" editorType="dxDateBox"></dxi-form-item>
        <dxi-form-item dataField="endDate" editorType="dxDateBox"></dxi-form-item>
      </dx-form>
    </div>
    <div class="toolbar m-3">
      <button class="btn btn-primary" (click)="getData()">Search</button>
    </div>
    <div class="toolbar m-3">
      <button class="btn btn-primary" (click)="getTimeSpan('week')">Last Week</button>
    </div>
    <div class="toolbar m-3">
      <button class="btn btn-primary" (click)="getTimeSpan('month')">Last Month</button>
    </div>
  </div>

  <div class="d-flex flex-column flex-fill dx-card">
    <!-- <div class="d-flex mt-3 ms-3">
    <dx-form [formData]="filter" style="max-width: 150px">
      <dxi-item dataField="startDate" editorType="dxDateBox"></dxi-item>
      <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
    </dx-form>
    <div class="d-flex flex-column ms-3 mt-3">
      <button class="btn btn-primary" (click)="getData()">Search</button>
    </div>

    <div class="card card-body d-flex flex-column ms-4">
      <h4 style="text-align: center">Load Times</h4>
      <h5>Load Count: {{ averageLoadTimes?.loadCount | number }}</h5>
      <span [ngClass]="'load-time' + (averageLoadTimes?.average < 100 ? ' green' : ' red')">
        <h5>Average Time (min/load): {{ averageLoadTimes?.average | number : '1.2-2' }}</h5>
        <h5>Average Time (hr/load): {{ averageLoadTimes?.average / 60 | number : '1.2-2' }}</h5>
        <h5>Tons {{ averageLoadTimes?.totalTons | number : '1.2-2' }}</h5>
        <h5>Tons {{ averageLoadTimes?.totalTons / averageLoadTimes?.loadCount | number : '1.2-2' }}</h5>
        <h5>Tons {{ averageLoadTimes?.averageTons | number : '1.2-2' }}</h5>
        <h5>Ton Exp {{ averageLoadTimes?.totalTonExpense | number : '1.2-2' }}</h5>
        <h5>Avg Ton Exp / Load {{ averageLoadTimes?.avgTonExpensePerLoad | number : '1.2-2' }}</h5>
        <h5>Avg Ton Exp / Load {{ averageLoadTimes?.totalTonExpense / averageLoadTimes?.loadCount | number : '1.2-2' }}</h5>
      </span>
    </div>
  </div> -->
  <div class="d-flex mt-3 ms-3">
    <div class="flex-column">
      <div class="card dashboard-card card-body ms-4">
        <div class="d-flex">
          <div class="flex-row ticker px-3">
            <div class="icon-wrapper info">
              <i [class]="'dx-icon dx-icon-chart'"></i>
            </div>
          </div>
          <div class="flex-row px-3">
            <h4 style="text-align: center">Invoices</h4>
            <h3 [style]="'font-weight: bold; color: green'">Total {{ invoiceInfos?.totalInvoices | currency }}</h3>
            <h4 [style]="'font-weight: bold; color: red'">UnPaid {{ invoiceInfos?.totalUnpaid | currency }}</h4>
            <h5>Invoice Count: {{ invoiceInfos?.totalInvoicesCount | number }}</h5>
            <h4 class="indented">Customers: {{ invoiceInfos?.distinctCustomersCount }}</h4>
            <!-- <h4 class="indented">Load Count: {{ invoiceInfos?.totalLoadCount }}</h4> -->
          </div>
        </div>
      </div>
      <div class="card dashboard-card card-body mt-4 ms-4">
        <div class="d-flex">
          <div class="flex-row ticker px-3">
            <div class="icon-wrapper positive">
              <i [class]="'dx-icon dx-icon-money'"></i>
            </div>
          </div>
          <div class="flex-row px-3">
            <h4 style="text-align: center">Revenue (by Jobs)</h4>
            <!-- <h3 [style]="'font-weight: bold; color: green'">Total {{ invoiceInfos?.totalInvoices | currency }}</h3>
            <h4 [style]="'font-weight: bold; color: red'">UnPaid {{ invoiceInfos?.totalUnpaid | currency }}</h4>
            <h5>Invoice Count: {{ invoiceInfos?.totalInvoicesCount | number }}</h5>
            <h4 class="indented">Customers: {{ invoiceInfos?.distinctCustomersCount }}</h4> -->
            <!-- <h4 class="indented">Load Count: {{ invoiceInfos?.totalLoadCount }}</h4> -->

            <h3 class="dashboard-top-margin dashboard-green bold">
              Total: {{ dashboardInfos?.revenueByJobsNonVoided | currency }}
            </h3>
            <!-- <h4>Revenue (by invoices) {{ dashboardInfos?.revenueByInvoice | currency }}</h4> -->
            <h4 class="indented">Rev/Load {{ dashboardInfos?.revenuePerLoad | currency }}</h4>
            <h4 class="indented">Profit/Load {{ dashboardInfos?.profitPerLoad | currency }}</h4>
            <h4 class="indented">Margin/Load {{ dashboardInfos?.marginPerLoad | percent : '1.2-2' }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-body ms-4 dashboard-flex pe-5">
      <div class="d-flex">
        <div class="flex-row ticker px-3">
          <div class="icon-wrapper neutral">
            <i [class]="'dx-icon dx-icon-trash'"></i>
          </div>
        </div>
        <div class="flex-row px-3">
          <h4 style="text-align: center">Job Information</h4>
          <h5>Loads: {{ dashboardInfos?.loadsCount | number }}</h5>
          <h5>Deliveries: {{ dashboardInfos?.deliveryCount | number }}</h5>

          <h5 [style]="'margin-top: 18px'">Total Tons: {{ dashboardInfos?.totalTons | number : '1.2-2' }}</h5>
          <h5 class="indented">Dumping Expense {{ dashboardInfos?.totalDumpingExpense | currency }}</h5>
          <h5 class="indented">Disposal/Load {{ dashboardInfos?.disposalCostPerLoad | currency }}</h5>

          <h5 [style]="'margin-top: 8px'">Total Time (hrs): {{ dashboardInfos?.totalTime / 60 | number : '1.2-2' }}</h5>
          <h5 class="indented">Hauling Expense {{ dashboardInfos?.totalHaulingExpense | currency }}</h5>
          <h5 class="indented">$Hr/Load {{ dashboardInfos?.hourlyExpensePerLoad | currency }}</h5>
          <!-- <h5 class="indented">Hours {{ dashboardInfos?.totalTime / 60 | number : '1.2-2' }}</h5> -->

          <!-- <h4 class="dashboard-top-margin">Revenue (by jobs) {{ dashboardInfos?.revenueByJobs | currency }}</h4>
          <h4>Revenue (by invoices) {{ dashboardInfos?.revenueByInvoice | currency }}</h4>
          <h4>Rev/Load {{ dashboardInfos?.revenuePerLoad | currency }}</h4>
          <h4>Profit/Load {{ dashboardInfos?.profitPerLoad | currency }}</h4>
          <h4>Margin/Load {{ dashboardInfos?.marginPerLoad | percent : '1.2-2' }}</h4> -->
        </div>
      </div>
    </div>
    <!-- <div class="card card-body d-flex flex-row ms-4">
    <div class="d-flex flex-column px-3">
      <h4 style="text-align: center">Jobs Info</h4>
      <h5>Loads: {{ dashboardInfos?.loadsCount | number }}</h5>
      <h5>Deliveries: {{ dashboardInfos?.deliveryCount | number }}</h5>

      <h5 [style]="'margin-top: 8px'">Total Tons: {{ dashboardInfos?.totalTons | number : '1.2-2' }}</h5>
      <h5 class="indented">Dumping Expense {{ dashboardInfos?.totalDumpingExpense | currency }}</h5>
      <h5 class="indented">Disposal/Load {{ dashboardInfos?.disposalCostPerLoad | currency }}</h5>

      <h5 [style]="'margin-top: 8px'">Total Time (hrs): {{ dashboardInfos?.totalTime | number : '1.2-2' }}</h5>
      <h5 class="indented">Hauling Expense {{ dashboardInfos?.totalHaulingExpense | currency }}</h5>
      <h5 class="indented">$Hr/Load {{ dashboardInfos?.hourlyExpensePerLoad | currency }}</h5>

      <h4 class="dashboard-top-margin">Revenue (by jobs) {{ dashboardInfos?.revenueByJobs | currency }}</h4>
      <h4>Revenue (by invoices) {{ dashboardInfos?.revenueByInvoice | currency }}</h4>
      <h4>Rev/Load {{ dashboardInfos?.revenuePerLoad | currency }}</h4>
      <h4>Profit/Load {{ dashboardInfos?.profitPerLoad | currency }}</h4>
      <h4>Margin/Load {{ dashboardInfos?.marginPerLoad | percent : '1.2-2' }}</h4>
    </div>
  </div> -->
  <div class="card card-body d-flex flex-column ms-4 dashboard-flex px-5">
    <h4 style="text-align: center">Jobs Times</h4>
    <h5>Job Count: {{ dashboardInfos?.jobCount | number }}</h5>
    <h5>Average Time (min/job): {{ dashboardInfos?.average | number : '1.2-2' }}</h5>
    <h5>Delivery Count: {{ dashboardInfos?.deliveryCount | number }}</h5>
    <h5>Delivery Avg. (min): {{ dashboardInfos?.deliveryAverage | number : '1.2-2' }}</h5>
    <h5>Pickup Count: {{ dashboardInfos?.loadsCount | number }}</h5>
    <h5>Pickup Avg. (min): {{ dashboardInfos?.pickupAverage | number : '1.2-2' }}</h5>
  </div>

  <div class="flex-column">
    @if (!!tonsDumped) {
      <div class="card dashboard-card card-body tons-dumped-table">
        <h4 style="text-align: center">Dumpster Tons By Type Summary</h4>
        <table class="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            @for (category of tonsDumped.categories; track category) {
              <tr>
                <td class="col-xs-2 table-little-padding">{{ category.name }}</td>
                <td class="col-xs-1 table-little-padding total-right-align">{{ category.tons | number }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <div class="card dashboard-card card-body tons-dumped-table mt-4">
      <h4 style="text-align: center">Extra Expense Jobs</h4>
      <h5>Count: {{ dashboardInfos?.extraExpenseCount | number }}</h5>
    </div>
  </div>

  <div class="flex-column">
    <div class="card dashboard-card card-body tons-dumped-table">
      <h4 style="text-align: center">Jobs Not Using Preferred Dumpster</h4>
      <table class="table">
        <thead>
          <tr>
            <th>Preferred Size</th>
            <th>Jobs Substituted</th>
          </tr>
        </thead>
        <tbody>
          @for (dumpster of subbedDumpsters?.data; track dumpster) {
            <tr>
              <td class="col-xs-2 table-little-padding">{{ dumpster.CustomerPreferred }}</td>
              <td class="col-xs-1 table-little-padding table-center-align">{{ dumpster.Count | number }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="card dashboard-card card-body tons-dumped-table mt-4">
      <h4 style="text-align: center">Lost Jobs</h4>
      <table class="table">
        <thead>
          <tr>
            <th>Dumpster</th>
            <th>Jobs Lost</th>
          </tr>
        </thead>
        <tbody>
          @for (dumpster of lostJobsByDumpster?.data; track dumpster) {
            <tr>
              <td class="col-xs-2 table-little-padding">{{ dumpster.Dumpster }}</td>
              <td class="col-xs-1 table-little-padding table-center-align">{{ dumpster.Count | number }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- <div class="card card-body d-flex flex-column ms-4">
  <h4 style="text-align: center">Jobs Using Trailers</h4>
  <h5>{{ jobsUsingTrailer }}</h5>
</div> -->
<!-- <div class="col-sm-9">
<dx-chart id="chart" title="OnTime" [dataSource]="chartEntities" [style]="{ height: '325px' }">
  <dxi-series valueField="onTimeCount" name="On Time" color="green"></dxi-series>
  <dxi-series valueField="lateCount" name="Late" color="red"></dxi-series>
  <dxi-value-axis position="left">
    <dxo-title text="Count"></dxo-title>
  </dxi-value-axis>
  <dxo-common-series-settings argumentField="weekDue" type="stackedBar"></dxo-common-series-settings>
  <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top"> </dxo-legend>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip"> </dxo-tooltip>
</dx-chart>
</div> -->
</div>
<div class="d-flex mt-3 ms-3" style="border-top: 1px solid"></div>
<div class="d-flex mt-3 ms-3">
  <div class="card card-body d-flex flex-fill flex-column col-sm-3 pt-3 pb-2 px-2">
    <dx-data-grid
      #dataGrid
      keyExpr="id"
      class="flex-fill d-flex flex-column"
      height="100%"
      [dataSource]="dumpstersOnSite"
      [showBorders]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      [columnAutoWidth]="false"
      >
      <dxi-data-grid-column dataField="size" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="dumpsterNumber" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="placed" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="removed" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="timeOnSite" caption="DaysOnSite" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column></dxi-data-grid-column>

      <dxo-data-grid-summary>
        <dxi-data-grid-total-item column="timeOnSite" summaryType="avg" valueFormat="#0.000"> </dxi-data-grid-total-item>
        <dxi-data-grid-group-item column="timeOnSite" summaryType="avg" valueFormat="#0.000"> </dxi-data-grid-group-item>
      </dxo-data-grid-summary>
      <dxo-data-grid-grouping [autoExpandAll]="false"> </dxo-data-grid-grouping>

      <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
      <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
      <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
      <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
      <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
      <dxo-data-grid-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="dashboard-dumpster-locations-grid"
      ></dxo-data-grid-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'"></div>
      <div *dxTemplate="let data of 'toolbarText'">
        <!-- <span *ngIf="jobCounts?.jobCounts" class="me-3">
        <strong>{{ jobsGrid.instance.totalCount() + ' items' }}</strong>
      </span> -->
    </div>
  </dx-data-grid>
</div>
<div class="d-flex">
  <div class="card dashboard-card card-body tons-dumped-table">
    <h4 style="text-align: center">Average Margin By Dumpster</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Load Count</th>
          <th>Average Margin</th>
          <th>Average Weight</th>
        </tr>
      </thead>
      <tbody>
        @for (dumpster of dumpsterMargins?.data; track dumpster) {
          <tr>
            <td class="col-xs-2 table-little-padding">{{ dumpster.BillAs }}</td>
            <td class="col-xs-1 table-little-padding table-center-align">{{ dumpster.Count | number }}</td>
            <td class="col-xs-1 table-little-padding table-center-align">
              {{ dumpster.AverageMargin | percent : '1.2-2' }}
            </td>
            <td class="col-xs-1 table-little-padding table-center-align">
              {{ dumpster.AverageWeight | number : '1.2-2' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="card card-body d-flex flex-column ms-4">
  @if (availabilityInfos) {
    <dx-chart
      id="chart"
      title="Availability"
      [dataSource]="availabilityInfos"
      (onLegendClick)="onAvailabilityLegendClick($event)"
      >
      >
      <dxi-chart-series valueField="AvailableCount10" name="10 yd"></dxi-chart-series>
      <dxi-chart-series valueField="AvailableCount15" name="15 yd"></dxi-chart-series>
      <dxi-chart-series valueField="AvailableCount20" name="20 yd"></dxi-chart-series>
      <dxi-chart-series valueField="AvailableCount30" name="30 yd"></dxi-chart-series>
      <dxi-chart-series valueField="AvailableCount40" name="40 yd"></dxi-chart-series>
      <dxo-chart-common-series-settings argumentField="DateString" type="bar"></dxo-chart-common-series-settings>
      <dxo-chart-legend verticalAlignment="bottom" horizontalAlignment="center"> </dxo-chart-legend>
      <dxo-chart-export [enabled]="true"></dxo-chart-export>
    </dx-chart>
  }
</div>
</div>

<div class="d-flex mt-3 ms-3" style="border-top: 1px solid">
  <div class="d-flex flex-column flex-fill p-1">
    <dx-data-grid
      #dataGrid
      keyExpr="id"
      class="flex-fill d-flex flex-column"
      height="950px"
      [dataSource]="invoices"
      [showBorders]="true"
      [columnAutoWidth]="false"
      >
      <dxi-data-grid-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="createDate" caption="Created" dataType="date" width="125"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="invoiceNumber" caption="Invoice #" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="rentalIdDisplay" caption="Rental" width="75" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="statusName" caption="Status" width="100"> </dxi-data-grid-column>
      <dxi-data-grid-column
        dataField="customerDisplayName"
        caption="Customer"
        width="175"
        cellTemplate="customerLinkTemplate"
      ></dxi-data-grid-column>
      <dxi-data-grid-column dataField="displayServiceAddress" caption="Service Address" width="150"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="paid" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="invoiceDate" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="dueDate" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="200"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="unpaidBalance" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-data-grid-column>
      <dxi-data-grid-column
        dataField="jobMargin"
        caption="Job Margins"
        [format]="{ type: 'percent', precision: 2 }"
        width="100"
      ></dxi-data-grid-column>
      <dxi-data-grid-column
        dataField="rentalMargin"
        caption="Rental Margin"
        [format]="{ type: 'percent', precision: 2 }"
        width="100"
      ></dxi-data-grid-column>
      <dxi-data-grid-column dataField="deleted" dataType="date" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="isPaid" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="isDeleted" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="margins" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column></dxi-data-grid-column>

      <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
        @if (cell) {
          <a [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
        }
      </div>
      <div *dxTemplate="let cell of 'rentalLinkTemplate'">
        @if (cell && !cell.data.rentalId) {
          <p [innerHtml]="cell.text"></p>
        }
        @if (cell && cell.data.rentalId) {
          <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
        }
      </div>
      <div *dxTemplate="let cell of 'customerLinkTemplate'">
        @if (cell) {
          <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
        }
      </div>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <!-- <button
        class="btn btn-sm btn-success me-1 mb-2"
        (click)="calculateJobMargins()"
        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
        [hidden]="!isInvoiceAdmin"
        >
        ReCalculate Margins
      </button> -->
    </div>

    <div *dxTemplate="let data of 'toolbarText'">
      @if (dataGrid) {
        <span class="me-3">
          <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
        </span>
      }
    </div>

    <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
    <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
    <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="invoice-history-grid"></dxo-data-grid-state-storing>

    <dxo-data-grid-summary>
      <dxi-data-grid-total-item
        column="total"
        summaryType="sum"
        [displayFormat]="'{0}'"
        [valueFormat]="{ type: 'currency', precision: 2 }"
        >
      </dxi-data-grid-total-item>
      <dxi-data-grid-total-item
        column="unpaidBalance"
        summaryType="sum"
        [displayFormat]="'{0}'"
        [valueFormat]="{ type: 'currency', precision: 2 }"
        >
      </dxi-data-grid-total-item>
      <dxi-data-grid-total-item
        column="jobMargin"
        summaryType="avg"
        [displayFormat]="'{0}'"
        [valueFormat]="{ type: 'percent', precision: 2 }"
        >
      </dxi-data-grid-total-item>
    </dxo-data-grid-summary>
  </dx-data-grid>
</div>
</div>
</div>
</div>
